import { kFormat } from 'container/Projects/LiveProjects/Project/IdeaLab/utils'

import s from './VolumePill.module.css'

type Props = {
  value: number
}

export const VolumePill = ({ value }: Props) => {
  return (
    <div title={`Search volume: ${kFormat(value)}`} className={s.volume}>
      {kFormat(value)}
    </div>
  )
}
